/** So "xo" matches "Xô" and "duong" matches "Đường". */
export function foldSearch(value: string): string {
  return value
    .normalize("NFD")
    .replace(/\p{M}/gu, "")
    .toLowerCase()
    .replace(/đ/g, "d");
}
